import { all, put } from 'redux-saga/effects';

export function* setPrefillData({ actions }, socialData) {
    yield all([
        put(actions.setDataFieldValue('uid', socialData.uid, true)),
        put(actions.setDataFieldValue('firstName', socialData.firstName, true)),
        put(actions.setDataFieldValue('lastName', socialData.lastName, true)),
        put(actions.setDataFieldValue('socialProfileId', socialData.socialProfile.id, true)),
        put(
            actions.setDataFieldValue(
                'socialProfileProvider',
                socialData.socialProfile.provider,
                true,
            ),
        ),
        put(
            actions.setDataFieldValue(
                'socialProfileAccessToken',
                socialData.socialProfile.accessToken,
                true,
            ),
        ),
    ]);
}

export const getPrefillValue = (prefillSource = {}, fieldName) => {
    const {
        defaultAddress = {},
        personalInformation = {},
        preferencesInformation = {},
        gdprServiceInformation = {},
    } = prefillSource;

    const { privacyCommunicationChannels = {} } = gdprServiceInformation;

    switch (fieldName) {
        case 'gender':
        case 'line1':
        case 'line2':
        case 'pobox':
        case 'mobileNumber':
        case 'town':
        case 'district':
        case 'postalCode':
        case 'building':
        case 'line3':
        case 'remarks':
        case 'jobTitle':
            return defaultAddress[fieldName] || null;
        case 'title':
            return prefillSource.titleCode || prefillSource.title || null;
        case 'province':
            return defaultAddress[fieldName] || null;
        case 'phone':
            return defaultAddress.formattedPhone || defaultAddress.phone || null;
        case 'dateOfBirth':
            return personalInformation[fieldName] || null;
        case 'country':
            return defaultAddress.country ? defaultAddress.country.isocode : null;
        case 'communicationMethod':
            return preferencesInformation[fieldName] || null;
        case 'email':
        case 'mail':
        case 'sms':
        case 'telephone':
        case 'withdraw':
            return privacyCommunicationChannels[fieldName] || null;
        case 'displayUid':
        case 'name':
        case 'message':
        case 'subject':
        case 'orderNumber':
        case 'orderReference':
        case 'dataProtectionAccepted':
            return prefillSource[fieldName] || null;
        default:
            if (prefillSource[fieldName]) return prefillSource[fieldName];
    }
};
